/**
 * Timezone type definition
 *
 * @typedef {Object} Timezone
 * @property {String} key       key of the timezone
 * @property {String} value     value of the timezone
 * @property {String} offset    offset of the timezone
 */

/**
 * Timezones Collection.
 *
 * Contains a static list of all timezones and their offset.
 *
 * @returns Timezone[]
 */
export default [
  {
    value: 'Africa/Abidjan',
    key: 'Africa/Abidjan',
    offset: 'GMT',
  },
  {
    value: 'Africa/Accra',
    key: 'Africa/Accra',
    offset: 'GMT',
  },
  {
    value: 'Africa/Addis_Ababa',
    key: 'Africa/Addis_Ababa',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Algiers',
    key: 'Africa/Algiers',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Asmera',
    key: 'Africa/Asmera',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Bamako',
    key: 'Africa/Bamako',
    offset: 'GMT',
  },
  {
    value: 'Africa/Bangui',
    key: 'Africa/Bangui',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Banjul',
    key: 'Africa/Banjul',
    offset: 'GMT',
  },
  {
    value: 'Africa/Bissau',
    key: 'Africa/Bissau',
    offset: 'GMT',
  },
  {
    value: 'Africa/Blantyre',
    key: 'Africa/Blantyre',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Brazzaville',
    key: 'Africa/Brazzaville',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Bujumbura',
    key: 'Africa/Bujumbura',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Cairo',
    key: 'Africa/Cairo',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Casablanca',
    key: 'Africa/Casablanca',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Ceuta',
    key: 'Africa/Ceuta',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Conakry',
    key: 'Africa/Conakry',
    offset: 'GMT',
  },
  {
    value: 'Africa/Dakar',
    key: 'Africa/Dakar',
    offset: 'GMT',
  },
  {
    value: 'Africa/Dar_es_Salaam',
    key: 'Africa/Dar_es_Salaam',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Djibouti',
    key: 'Africa/Djibouti',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Douala',
    key: 'Africa/Douala',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/El_Aaiun',
    key: 'Africa/El_Aaiun',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Freetown',
    key: 'Africa/Freetown',
    offset: 'GMT',
  },
  {
    value: 'Africa/Gaborone',
    key: 'Africa/Gaborone',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Harare',
    key: 'Africa/Harare',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Johannesburg',
    key: 'Africa/Johannesburg',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Juba',
    key: 'Africa/Juba',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Kampala',
    key: 'Africa/Kampala',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Khartoum',
    key: 'Africa/Khartoum',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Kigali',
    key: 'Africa/Kigali',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Kinshasa',
    key: 'Africa/Kinshasa',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Lagos',
    key: 'Africa/Lagos',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Libreville',
    key: 'Africa/Libreville',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Lome',
    key: 'Africa/Lome',
    offset: 'GMT',
  },
  {
    value: 'Africa/Luanda',
    key: 'Africa/Luanda',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Lubumbashi',
    key: 'Africa/Lubumbashi',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Lusaka',
    key: 'Africa/Lusaka',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Malabo',
    key: 'Africa/Malabo',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Maputo',
    key: 'Africa/Maputo',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Maseru',
    key: 'Africa/Maseru',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Mbabane',
    key: 'Africa/Mbabane',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Mogadishu',
    key: 'Africa/Mogadishu',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Monrovia',
    key: 'Africa/Monrovia',
    offset: 'GMT',
  },
  {
    value: 'Africa/Nairobi',
    key: 'Africa/Nairobi',
    offset: 'GMT+3',
  },
  {
    value: 'Africa/Ndjamena',
    key: 'Africa/Ndjamena',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Niamey',
    key: 'Africa/Niamey',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Nouakchott',
    key: 'Africa/Nouakchott',
    offset: 'GMT',
  },
  {
    value: 'Africa/Ouagadougou',
    key: 'Africa/Ouagadougou',
    offset: 'GMT',
  },
  {
    value: 'Africa/Porto-Novo',
    key: 'Africa/Porto-Novo',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Sao_Tome',
    key: 'Africa/Sao_Tome',
    offset: 'GMT',
  },
  {
    value: 'Africa/Tripoli',
    key: 'Africa/Tripoli',
    offset: 'GMT+2',
  },
  {
    value: 'Africa/Tunis',
    key: 'Africa/Tunis',
    offset: 'GMT+1',
  },
  {
    value: 'Africa/Windhoek',
    key: 'Africa/Windhoek',
    offset: 'GMT+2',
  },
  {
    value: 'America/Adak',
    key: 'America/Adak',
    offset: 'GMT-9',
  },
  {
    value: 'America/Anchorage',
    key: 'America/Anchorage',
    offset: 'GMT-8',
  },
  {
    value: 'America/Anguilla',
    key: 'America/Anguilla',
    offset: 'GMT-4',
  },
  {
    value: 'America/Antigua',
    key: 'America/Antigua',
    offset: 'GMT-4',
  },
  {
    value: 'America/Araguaina',
    key: 'America/Araguaina',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/La_Rioja',
    key: 'America/Argentina/La_Rioja',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/Rio_Gallegos',
    key: 'America/Argentina/Rio_Gallegos',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/Salta',
    key: 'America/Argentina/Salta',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/San_Juan',
    key: 'America/Argentina/San_Juan',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/San_Luis',
    key: 'America/Argentina/San_Luis',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/Tucuman',
    key: 'America/Argentina/Tucuman',
    offset: 'GMT-3',
  },
  {
    value: 'America/Argentina/Ushuaia',
    key: 'America/Argentina/Ushuaia',
    offset: 'GMT-3',
  },
  {
    value: 'America/Aruba',
    key: 'America/Aruba',
    offset: 'GMT-4',
  },
  {
    value: 'America/Asuncion',
    key: 'America/Asuncion',
    offset: 'GMT-4',
  },
  {
    value: 'America/Bahia',
    key: 'America/Bahia',
    offset: 'GMT-3',
  },
  {
    value: 'America/Bahia_Banderas',
    key: 'America/Bahia_Banderas',
    offset: 'GMT-6',
  },
  {
    value: 'America/Barbados',
    key: 'America/Barbados',
    offset: 'GMT-4',
  },
  {
    value: 'America/Belem',
    key: 'America/Belem',
    offset: 'GMT-3',
  },
  {
    value: 'America/Belize',
    key: 'America/Belize',
    offset: 'GMT-6',
  },
  {
    value: 'America/Blanc-Sablon',
    key: 'America/Blanc-Sablon',
    offset: 'GMT-4',
  },
  {
    value: 'America/Boa_Vista',
    key: 'America/Boa_Vista',
    offset: 'GMT-4',
  },
  {
    value: 'America/Bogota',
    key: 'America/Bogota',
    offset: 'GMT-5',
  },
  {
    value: 'America/Boise',
    key: 'America/Boise',
    offset: 'GMT-6',
  },
  {
    value: 'America/Buenos_Aires',
    key: 'America/Buenos_Aires',
    offset: 'GMT-3',
  },
  {
    value: 'America/Cambridge_Bay',
    key: 'America/Cambridge_Bay',
    offset: 'GMT-6',
  },
  {
    value: 'America/Campo_Grande',
    key: 'America/Campo_Grande',
    offset: 'GMT-4',
  },
  {
    value: 'America/Cancun',
    key: 'America/Cancun',
    offset: 'GMT-5',
  },
  {
    value: 'America/Caracas',
    key: 'America/Caracas',
    offset: 'GMT-4',
  },
  {
    value: 'America/Catamarca',
    key: 'America/Catamarca',
    offset: 'GMT-3',
  },
  {
    value: 'America/Cayenne',
    key: 'America/Cayenne',
    offset: 'GMT-3',
  },
  {
    value: 'America/Cayman',
    key: 'America/Cayman',
    offset: 'GMT-5',
  },
  {
    value: 'America/Chicago',
    key: 'America/Chicago',
    offset: 'GMT-5',
  },
  {
    value: 'America/Chihuahua',
    key: 'America/Chihuahua',
    offset: 'GMT-6',
  },
  {
    value: 'America/Ciudad_Juarez',
    key: 'America/Ciudad_Juarez',
    offset: 'GMT-6',
  },
  {
    value: 'America/Coral_Harbour',
    key: 'America/Coral_Harbour',
    offset: 'GMT-5',
  },
  {
    value: 'America/Cordoba',
    key: 'America/Cordoba',
    offset: 'GMT-3',
  },
  {
    value: 'America/Costa_Rica',
    key: 'America/Costa_Rica',
    offset: 'GMT-6',
  },
  {
    value: 'America/Creston',
    key: 'America/Creston',
    offset: 'GMT-7',
  },
  {
    value: 'America/Cuiaba',
    key: 'America/Cuiaba',
    offset: 'GMT-4',
  },
  {
    value: 'America/Curacao',
    key: 'America/Curacao',
    offset: 'GMT-4',
  },
  {
    value: 'America/Danmarkshavn',
    key: 'America/Danmarkshavn',
    offset: 'GMT',
  },
  {
    value: 'America/Dawson',
    key: 'America/Dawson',
    offset: 'GMT-7',
  },
  {
    value: 'America/Dawson_Creek',
    key: 'America/Dawson_Creek',
    offset: 'GMT-7',
  },
  {
    value: 'America/Denver',
    key: 'America/Denver',
    offset: 'GMT-6',
  },
  {
    value: 'America/Detroit',
    key: 'America/Detroit',
    offset: 'GMT-4',
  },
  {
    value: 'America/Dominica',
    key: 'America/Dominica',
    offset: 'GMT-4',
  },
  {
    value: 'America/Edmonton',
    key: 'America/Edmonton',
    offset: 'GMT-6',
  },
  {
    value: 'America/Eirunepe',
    key: 'America/Eirunepe',
    offset: 'GMT-5',
  },
  {
    value: 'America/El_Salvador',
    key: 'America/El_Salvador',
    offset: 'GMT-6',
  },
  {
    value: 'America/Fort_Nelson',
    key: 'America/Fort_Nelson',
    offset: 'GMT-7',
  },
  {
    value: 'America/Fortaleza',
    key: 'America/Fortaleza',
    offset: 'GMT-3',
  },
  {
    value: 'America/Glace_Bay',
    key: 'America/Glace_Bay',
    offset: 'GMT-3',
  },
  {
    value: 'America/Godthab',
    key: 'America/Godthab',
    offset: 'GMT-2',
  },
  {
    value: 'America/Goose_Bay',
    key: 'America/Goose_Bay',
    offset: 'GMT-3',
  },
  {
    value: 'America/Grand_Turk',
    key: 'America/Grand_Turk',
    offset: 'GMT-4',
  },
  {
    value: 'America/Grenada',
    key: 'America/Grenada',
    offset: 'GMT-4',
  },
  {
    value: 'America/Guadeloupe',
    key: 'America/Guadeloupe',
    offset: 'GMT-4',
  },
  {
    value: 'America/Guatemala',
    key: 'America/Guatemala',
    offset: 'GMT-6',
  },
  {
    value: 'America/Guayaquil',
    key: 'America/Guayaquil',
    offset: 'GMT-5',
  },
  {
    value: 'America/Guyana',
    key: 'America/Guyana',
    offset: 'GMT-4',
  },
  {
    value: 'America/Halifax',
    key: 'America/Halifax',
    offset: 'GMT-3',
  },
  {
    value: 'America/Havana',
    key: 'America/Havana',
    offset: 'GMT-4',
  },
  {
    value: 'America/Hermosillo',
    key: 'America/Hermosillo',
    offset: 'GMT-7',
  },
  {
    value: 'America/Indiana/Knox',
    key: 'America/Indiana/Knox',
    offset: 'GMT-5',
  },
  {
    value: 'America/Indiana/Marengo',
    key: 'America/Indiana/Marengo',
    offset: 'GMT-4',
  },
  {
    value: 'America/Indiana/Petersburg',
    key: 'America/Indiana/Petersburg',
    offset: 'GMT-4',
  },
  {
    value: 'America/Indiana/Tell_City',
    key: 'America/Indiana/Tell_City',
    offset: 'GMT-5',
  },
  {
    value: 'America/Indiana/Vevay',
    key: 'America/Indiana/Vevay',
    offset: 'GMT-4',
  },
  {
    value: 'America/Indiana/Vincennes',
    key: 'America/Indiana/Vincennes',
    offset: 'GMT-4',
  },
  {
    value: 'America/Indiana/Winamac',
    key: 'America/Indiana/Winamac',
    offset: 'GMT-4',
  },
  {
    value: 'America/Indianapolis',
    key: 'America/Indianapolis',
    offset: 'GMT-4',
  },
  {
    value: 'America/Inuvik',
    key: 'America/Inuvik',
    offset: 'GMT-6',
  },
  {
    value: 'America/Iqaluit',
    key: 'America/Iqaluit',
    offset: 'GMT-4',
  },
  {
    value: 'America/Jamaica',
    key: 'America/Jamaica',
    offset: 'GMT-5',
  },
  {
    value: 'America/Jujuy',
    key: 'America/Jujuy',
    offset: 'GMT-3',
  },
  {
    value: 'America/Juneau',
    key: 'America/Juneau',
    offset: 'GMT-8',
  },
  {
    value: 'America/Kentucky/Monticello',
    key: 'America/Kentucky/Monticello',
    offset: 'GMT-4',
  },
  {
    value: 'America/Kralendijk',
    key: 'America/Kralendijk',
    offset: 'GMT-4',
  },
  {
    value: 'America/La_Paz',
    key: 'America/La_Paz',
    offset: 'GMT-4',
  },
  {
    value: 'America/Lima',
    key: 'America/Lima',
    offset: 'GMT-5',
  },
  {
    value: 'America/Los_Angeles',
    key: 'America/Los_Angeles',
    offset: 'GMT-7',
  },
  {
    value: 'America/Louisville',
    key: 'America/Louisville',
    offset: 'GMT-4',
  },
  {
    value: 'America/Lower_Princes',
    key: 'America/Lower_Princes',
    offset: 'GMT-4',
  },
  {
    value: 'America/Maceio',
    key: 'America/Maceio',
    offset: 'GMT-3',
  },
  {
    value: 'America/Managua',
    key: 'America/Managua',
    offset: 'GMT-6',
  },
  {
    value: 'America/Manaus',
    key: 'America/Manaus',
    offset: 'GMT-4',
  },
  {
    value: 'America/Marigot',
    key: 'America/Marigot',
    offset: 'GMT-4',
  },
  {
    value: 'America/Martinique',
    key: 'America/Martinique',
    offset: 'GMT-4',
  },
  {
    value: 'America/Matamoros',
    key: 'America/Matamoros',
    offset: 'GMT-5',
  },
  {
    value: 'America/Mazatlan',
    key: 'America/Mazatlan',
    offset: 'GMT-7',
  },
  {
    value: 'America/Mendoza',
    key: 'America/Mendoza',
    offset: 'GMT-3',
  },
  {
    value: 'America/Menominee',
    key: 'America/Menominee',
    offset: 'GMT-5',
  },
  {
    value: 'America/Merida',
    key: 'America/Merida',
    offset: 'GMT-6',
  },
  {
    value: 'America/Metlakatla',
    key: 'America/Metlakatla',
    offset: 'GMT-8',
  },
  {
    value: 'America/Mexico_City',
    key: 'America/Mexico_City',
    offset: 'GMT-6',
  },
  {
    value: 'America/Miquelon',
    key: 'America/Miquelon',
    offset: 'GMT-2',
  },
  {
    value: 'America/Moncton',
    key: 'America/Moncton',
    offset: 'GMT-3',
  },
  {
    value: 'America/Monterrey',
    key: 'America/Monterrey',
    offset: 'GMT-6',
  },
  {
    value: 'America/Montevideo',
    key: 'America/Montevideo',
    offset: 'GMT-3',
  },
  {
    value: 'America/Montreal',
    key: 'America/Montreal',
    offset: 'GMT-4',
  },
  {
    value: 'America/Montserrat',
    key: 'America/Montserrat',
    offset: 'GMT-4',
  },
  {
    value: 'America/Nassau',
    key: 'America/Nassau',
    offset: 'GMT-4',
  },
  {
    value: 'America/New_York',
    key: 'America/New_York',
    offset: 'GMT-4',
  },
  {
    value: 'America/Nipigon',
    key: 'America/Nipigon',
    offset: 'GMT-4',
  },
  {
    value: 'America/Nome',
    key: 'America/Nome',
    offset: 'GMT-8',
  },
  {
    value: 'America/Noronha',
    key: 'America/Noronha',
    offset: 'GMT-2',
  },
  {
    value: 'America/North_Dakota/Beulah',
    key: 'America/North_Dakota/Beulah',
    offset: 'GMT-5',
  },
  {
    value: 'America/North_Dakota/Center',
    key: 'America/North_Dakota/Center',
    offset: 'GMT-5',
  },
  {
    value: 'America/North_Dakota/New_Salem',
    key: 'America/North_Dakota/New_Salem',
    offset: 'GMT-5',
  },
  {
    value: 'America/Ojinaga',
    key: 'America/Ojinaga',
    offset: 'GMT-5',
  },
  {
    value: 'America/Panama',
    key: 'America/Panama',
    offset: 'GMT-5',
  },
  {
    value: 'America/Pangnirtung',
    key: 'America/Pangnirtung',
    offset: 'GMT-4',
  },
  {
    value: 'America/Paramaribo',
    key: 'America/Paramaribo',
    offset: 'GMT-3',
  },
  {
    value: 'America/Phoenix',
    key: 'America/Phoenix',
    offset: 'GMT-7',
  },
  {
    value: 'America/Port-au-Prince',
    key: 'America/Port-au-Prince',
    offset: 'GMT-4',
  },
  {
    value: 'America/Port_of_Spain',
    key: 'America/Port_of_Spain',
    offset: 'GMT-4',
  },
  {
    value: 'America/Porto_Velho',
    key: 'America/Porto_Velho',
    offset: 'GMT-4',
  },
  {
    value: 'America/Puerto_Rico',
    key: 'America/Puerto_Rico',
    offset: 'GMT-4',
  },
  {
    value: 'America/Punta_Arenas',
    key: 'America/Punta_Arenas',
    offset: 'GMT-3',
  },
  {
    value: 'America/Rainy_River',
    key: 'America/Rainy_River',
    offset: 'GMT-5',
  },
  {
    value: 'America/Rankin_Inlet',
    key: 'America/Rankin_Inlet',
    offset: 'GMT-5',
  },
  {
    value: 'America/Recife',
    key: 'America/Recife',
    offset: 'GMT-3',
  },
  {
    value: 'America/Regina',
    key: 'America/Regina',
    offset: 'GMT-6',
  },
  {
    value: 'America/Resolute',
    key: 'America/Resolute',
    offset: 'GMT-5',
  },
  {
    value: 'America/Rio_Branco',
    key: 'America/Rio_Branco',
    offset: 'GMT-5',
  },
  {
    value: 'America/Santa_Isabel',
    key: 'America/Santa_Isabel',
    offset: 'GMT-7',
  },
  {
    value: 'America/Santarem',
    key: 'America/Santarem',
    offset: 'GMT-3',
  },
  {
    value: 'America/Santiago',
    key: 'America/Santiago',
    offset: 'GMT-4',
  },
  {
    value: 'America/Santo_Domingo',
    key: 'America/Santo_Domingo',
    offset: 'GMT-4',
  },
  {
    value: 'America/Sao_Paulo',
    key: 'America/Sao_Paulo',
    offset: 'GMT-3',
  },
  {
    value: 'America/Scoresbysund',
    key: 'America/Scoresbysund',
    offset: 'GMT',
  },
  {
    value: 'America/Sitka',
    key: 'America/Sitka',
    offset: 'GMT-8',
  },
  {
    value: 'America/St_Barthelemy',
    key: 'America/St_Barthelemy',
    offset: 'GMT-4',
  },
  {
    value: 'America/St_Johns',
    key: 'America/St_Johns',
    offset: 'GMT-2:30',
  },
  {
    value: 'America/St_Kitts',
    key: 'America/St_Kitts',
    offset: 'GMT-4',
  },
  {
    value: 'America/St_Lucia',
    key: 'America/St_Lucia',
    offset: 'GMT-4',
  },
  {
    value: 'America/St_Thomas',
    key: 'America/St_Thomas',
    offset: 'GMT-4',
  },
  {
    value: 'America/St_Vincent',
    key: 'America/St_Vincent',
    offset: 'GMT-4',
  },
  {
    value: 'America/Swift_Current',
    key: 'America/Swift_Current',
    offset: 'GMT-6',
  },
  {
    value: 'America/Tegucigalpa',
    key: 'America/Tegucigalpa',
    offset: 'GMT-6',
  },
  {
    value: 'America/Thule',
    key: 'America/Thule',
    offset: 'GMT-3',
  },
  {
    value: 'America/Thunder_Bay',
    key: 'America/Thunder_Bay',
    offset: 'GMT-4',
  },
  {
    value: 'America/Tijuana',
    key: 'America/Tijuana',
    offset: 'GMT-7',
  },
  {
    value: 'America/Toronto',
    key: 'America/Toronto',
    offset: 'GMT-4',
  },
  {
    value: 'America/Tortola',
    key: 'America/Tortola',
    offset: 'GMT-4',
  },
  {
    value: 'America/Vancouver',
    key: 'America/Vancouver',
    offset: 'GMT-7',
  },
  {
    value: 'America/Whitehorse',
    key: 'America/Whitehorse',
    offset: 'GMT-7',
  },
  {
    value: 'America/Winnipeg',
    key: 'America/Winnipeg',
    offset: 'GMT-5',
  },
  {
    value: 'America/Yakutat',
    key: 'America/Yakutat',
    offset: 'GMT-8',
  },
  {
    value: 'America/Yellowknife',
    key: 'America/Yellowknife',
    offset: 'GMT-6',
  },
  {
    value: 'Antarctica/Casey',
    key: 'Antarctica/Casey',
    offset: 'GMT+11',
  },
  {
    value: 'Antarctica/Davis',
    key: 'Antarctica/Davis',
    offset: 'GMT+7',
  },
  {
    value: 'Antarctica/DumontDUrville',
    key: 'Antarctica/DumontDUrville',
    offset: 'GMT+10',
  },
  {
    value: 'Antarctica/Macquarie',
    key: 'Antarctica/Macquarie',
    offset: 'GMT+10',
  },
  {
    value: 'Antarctica/Mawson',
    key: 'Antarctica/Mawson',
    offset: 'GMT+5',
  },
  {
    value: 'Antarctica/McMurdo',
    key: 'Antarctica/McMurdo',
    offset: 'GMT+12',
  },
  {
    value: 'Antarctica/Palmer',
    key: 'Antarctica/Palmer',
    offset: 'GMT-3',
  },
  {
    value: 'Antarctica/Rothera',
    key: 'Antarctica/Rothera',
    offset: 'GMT-3',
  },
  {
    value: 'Antarctica/Syowa',
    key: 'Antarctica/Syowa',
    offset: 'GMT+3',
  },
  {
    value: 'Antarctica/Troll',
    key: 'Antarctica/Troll',
    offset: 'GMT+2',
  },
  {
    value: 'Antarctica/Vostok',
    key: 'Antarctica/Vostok',
    offset: 'GMT+6',
  },
  {
    value: 'Arctic/Longyearbyen',
    key: 'Arctic/Longyearbyen',
    offset: 'GMT+2',
  },
  {
    value: 'Asia/Aden',
    key: 'Asia/Aden',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Almaty',
    key: 'Asia/Almaty',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Amman',
    key: 'Asia/Amman',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Anadyr',
    key: 'Asia/Anadyr',
    offset: 'GMT+12',
  },
  {
    value: 'Asia/Aqtau',
    key: 'Asia/Aqtau',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Aqtobe',
    key: 'Asia/Aqtobe',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Ashgabat',
    key: 'Asia/Ashgabat',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Atyrau',
    key: 'Asia/Atyrau',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Baghdad',
    key: 'Asia/Baghdad',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Bahrain',
    key: 'Asia/Bahrain',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Baku',
    key: 'Asia/Baku',
    offset: 'GMT+4',
  },
  {
    value: 'Asia/Bangkok',
    key: 'Asia/Bangkok',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Barnaul',
    key: 'Asia/Barnaul',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Beirut',
    key: 'Asia/Beirut',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Bishkek',
    key: 'Asia/Bishkek',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Brunei',
    key: 'Asia/Brunei',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Calcutta',
    key: 'Asia/Calcutta',
    offset: 'GMT+5:30',
  },
  {
    value: 'Asia/Chita',
    key: 'Asia/Chita',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Choibalsan',
    key: 'Asia/Choibalsan',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Colombo',
    key: 'Asia/Colombo',
    offset: 'GMT+5:30',
  },
  {
    value: 'Asia/Damascus',
    key: 'Asia/Damascus',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Dhaka',
    key: 'Asia/Dhaka',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Dili',
    key: 'Asia/Dili',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Dubai',
    key: 'Asia/Dubai',
    offset: 'GMT+4',
  },
  {
    value: 'Asia/Dushanbe',
    key: 'Asia/Dushanbe',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Famagusta',
    key: 'Asia/Famagusta',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Gaza',
    key: 'Asia/Gaza',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Hebron',
    key: 'Asia/Hebron',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Hong_Kong',
    key: 'Asia/Hong_Kong',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Hovd',
    key: 'Asia/Hovd',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Irkutsk',
    key: 'Asia/Irkutsk',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Jakarta',
    key: 'Asia/Jakarta',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Jayapura',
    key: 'Asia/Jayapura',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Jerusalem',
    key: 'Asia/Jerusalem',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Kabul',
    key: 'Asia/Kabul',
    offset: 'GMT+4:30',
  },
  {
    value: 'Asia/Kamchatka',
    key: 'Asia/Kamchatka',
    offset: 'GMT+12',
  },
  {
    value: 'Asia/Karachi',
    key: 'Asia/Karachi',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Katmandu',
    key: 'Asia/Katmandu',
    offset: 'GMT+5:45',
  },
  {
    value: 'Asia/Khandyga',
    key: 'Asia/Khandyga',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Krasnoyarsk',
    key: 'Asia/Krasnoyarsk',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Kuala_Lumpur',
    key: 'Asia/Kuala_Lumpur',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Kuching',
    key: 'Asia/Kuching',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Kuwait',
    key: 'Asia/Kuwait',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Macau',
    key: 'Asia/Macau',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Magadan',
    key: 'Asia/Magadan',
    offset: 'GMT+11',
  },
  {
    value: 'Asia/Makassar',
    key: 'Asia/Makassar',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Manila',
    key: 'Asia/Manila',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Muscat',
    key: 'Asia/Muscat',
    offset: 'GMT+4',
  },
  {
    value: 'Asia/Nicosia',
    key: 'Asia/Nicosia',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Novokuznetsk',
    key: 'Asia/Novokuznetsk',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Novosibirsk',
    key: 'Asia/Novosibirsk',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Omsk',
    key: 'Asia/Omsk',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Oral',
    key: 'Asia/Oral',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Phnom_Penh',
    key: 'Asia/Phnom_Penh',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Pontianak',
    key: 'Asia/Pontianak',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Pyongyang',
    key: 'Asia/Pyongyang',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Qatar',
    key: 'Asia/Qatar',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Qostanay',
    key: 'Asia/Qostanay',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Qyzylorda',
    key: 'Asia/Qyzylorda',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Rangoon',
    key: 'Asia/Rangoon',
    offset: 'GMT+6:30',
  },
  {
    value: 'Asia/Riyadh',
    key: 'Asia/Riyadh',
    offset: 'GMT+3',
  },
  {
    value: 'Asia/Saigon',
    key: 'Asia/Saigon',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Sakhalin',
    key: 'Asia/Sakhalin',
    offset: 'GMT+11',
  },
  {
    value: 'Asia/Samarkand',
    key: 'Asia/Samarkand',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Seoul',
    key: 'Asia/Seoul',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Shanghai',
    key: 'Asia/Shanghai',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Singapore',
    key: 'Asia/Singapore',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Srednekolymsk',
    key: 'Asia/Srednekolymsk',
    offset: 'GMT+11',
  },
  {
    value: 'Asia/Taipei',
    key: 'Asia/Taipei',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Tashkent',
    key: 'Asia/Tashkent',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Tbilisi',
    key: 'Asia/Tbilisi',
    offset: 'GMT+4',
  },
  {
    value: 'Asia/Tehran',
    key: 'Asia/Tehran',
    offset: 'GMT+3:30',
  },
  {
    value: 'Asia/Thimphu',
    key: 'Asia/Thimphu',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Tokyo',
    key: 'Asia/Tokyo',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Tomsk',
    key: 'Asia/Tomsk',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Ulaanbaatar',
    key: 'Asia/Ulaanbaatar',
    offset: 'GMT+8',
  },
  {
    value: 'Asia/Urumqi',
    key: 'Asia/Urumqi',
    offset: 'GMT+6',
  },
  {
    value: 'Asia/Ust-Nera',
    key: 'Asia/Ust-Nera',
    offset: 'GMT+10',
  },
  {
    value: 'Asia/Vientiane',
    key: 'Asia/Vientiane',
    offset: 'GMT+7',
  },
  {
    value: 'Asia/Vladivostok',
    key: 'Asia/Vladivostok',
    offset: 'GMT+10',
  },
  {
    value: 'Asia/Yakutsk',
    key: 'Asia/Yakutsk',
    offset: 'GMT+9',
  },
  {
    value: 'Asia/Yekaterinburg',
    key: 'Asia/Yekaterinburg',
    offset: 'GMT+5',
  },
  {
    value: 'Asia/Yerevan',
    key: 'Asia/Yerevan',
    offset: 'GMT+4',
  },
  {
    value: 'Atlantic/Azores',
    key: 'Atlantic/Azores',
    offset: 'GMT',
  },
  {
    value: 'Atlantic/Bermuda',
    key: 'Atlantic/Bermuda',
    offset: 'GMT-3',
  },
  {
    value: 'Atlantic/Canary',
    key: 'Atlantic/Canary',
    offset: 'GMT+1',
  },
  {
    value: 'Atlantic/Cape_Verde',
    key: 'Atlantic/Cape_Verde',
    offset: 'GMT-1',
  },
  {
    value: 'Atlantic/Faeroe',
    key: 'Atlantic/Faeroe',
    offset: 'GMT+1',
  },
  {
    value: 'Atlantic/Madeira',
    key: 'Atlantic/Madeira',
    offset: 'GMT+1',
  },
  {
    value: 'Atlantic/Reykjavik',
    key: 'Atlantic/Reykjavik',
    offset: 'GMT',
  },
  {
    value: 'Atlantic/South_Georgia',
    key: 'Atlantic/South_Georgia',
    offset: 'GMT-2',
  },
  {
    value: 'Atlantic/St_Helena',
    key: 'Atlantic/St_Helena',
    offset: 'GMT',
  },
  {
    value: 'Atlantic/Stanley',
    key: 'Atlantic/Stanley',
    offset: 'GMT-3',
  },
  {
    value: 'Australia/Adelaide',
    key: 'Australia/Adelaide',
    offset: 'GMT+9:30',
  },
  {
    value: 'Australia/Brisbane',
    key: 'Australia/Brisbane',
    offset: 'GMT+10',
  },
  {
    value: 'Australia/Broken_Hill',
    key: 'Australia/Broken_Hill',
    offset: 'GMT+9:30',
  },
  {
    value: 'Australia/Currie',
    key: 'Australia/Currie',
    offset: 'GMT+10',
  },
  {
    value: 'Australia/Darwin',
    key: 'Australia/Darwin',
    offset: 'GMT+9:30',
  },
  {
    value: 'Australia/Eucla',
    key: 'Australia/Eucla',
    offset: 'GMT+8:45',
  },
  {
    value: 'Australia/Hobart',
    key: 'Australia/Hobart',
    offset: 'GMT+10',
  },
  {
    value: 'Australia/Lindeman',
    key: 'Australia/Lindeman',
    offset: 'GMT+10',
  },
  {
    value: 'Australia/Lord_Howe',
    key: 'Australia/Lord_Howe',
    offset: 'GMT+10:30',
  },
  {
    value: 'Australia/Melbourne',
    key: 'Australia/Melbourne',
    offset: 'GMT+10',
  },
  {
    value: 'Australia/Perth',
    key: 'Australia/Perth',
    offset: 'GMT+8',
  },
  {
    value: 'Australia/Sydney',
    key: 'Australia/Sydney',
    offset: 'GMT+10',
  },
  {
    value: 'Europe/Amsterdam',
    key: 'Europe/Amsterdam',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Andorra',
    key: 'Europe/Andorra',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Astrakhan',
    key: 'Europe/Astrakhan',
    offset: 'GMT+4',
  },
  {
    value: 'Europe/Athens',
    key: 'Europe/Athens',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Belgrade',
    key: 'Europe/Belgrade',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Berlin',
    key: 'Europe/Berlin',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Bratislava',
    key: 'Europe/Bratislava',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Brussels',
    key: 'Europe/Brussels',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Bucharest',
    key: 'Europe/Bucharest',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Budapest',
    key: 'Europe/Budapest',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Busingen',
    key: 'Europe/Busingen',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Chisinau',
    key: 'Europe/Chisinau',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Copenhagen',
    key: 'Europe/Copenhagen',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Dublin',
    key: 'Europe/Dublin',
    offset: 'GMT+1',
  },
  {
    value: 'Europe/Gibraltar',
    key: 'Europe/Gibraltar',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Guernsey',
    key: 'Europe/Guernsey',
    offset: 'GMT+1',
  },
  {
    value: 'Europe/Helsinki',
    key: 'Europe/Helsinki',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Isle_of_Man',
    key: 'Europe/Isle_of_Man',
    offset: 'GMT+1',
  },
  {
    value: 'Europe/Istanbul',
    key: 'Europe/Istanbul',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Jersey',
    key: 'Europe/Jersey',
    offset: 'GMT+1',
  },
  {
    value: 'Europe/Kaliningrad',
    key: 'Europe/Kaliningrad',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Kiev',
    key: 'Europe/Kiev',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Kirov',
    key: 'Europe/Kirov',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Lisbon',
    key: 'Europe/Lisbon',
    offset: 'GMT+1',
  },
  {
    value: 'Europe/Ljubljana',
    key: 'Europe/Ljubljana',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/London',
    key: 'Europe/London',
    offset: 'GMT+1',
  },
  {
    value: 'Europe/Luxembourg',
    key: 'Europe/Luxembourg',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Madrid',
    key: 'Europe/Madrid',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Malta',
    key: 'Europe/Malta',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Mariehamn',
    key: 'Europe/Mariehamn',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Minsk',
    key: 'Europe/Minsk',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Monaco',
    key: 'Europe/Monaco',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Moscow',
    key: 'Europe/Moscow',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Oslo',
    key: 'Europe/Oslo',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Paris',
    key: 'Europe/Paris',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Podgorica',
    key: 'Europe/Podgorica',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Prague',
    key: 'Europe/Prague',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Riga',
    key: 'Europe/Riga',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Rome',
    key: 'Europe/Rome',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Samara',
    key: 'Europe/Samara',
    offset: 'GMT+4',
  },
  {
    value: 'Europe/San_Marino',
    key: 'Europe/San_Marino',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Sarajevo',
    key: 'Europe/Sarajevo',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Saratov',
    key: 'Europe/Saratov',
    offset: 'GMT+4',
  },
  {
    value: 'Europe/Simferopol',
    key: 'Europe/Simferopol',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Skopje',
    key: 'Europe/Skopje',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Sofia',
    key: 'Europe/Sofia',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Stockholm',
    key: 'Europe/Stockholm',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Tallinn',
    key: 'Europe/Tallinn',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Tirane',
    key: 'Europe/Tirane',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Ulyanovsk',
    key: 'Europe/Ulyanovsk',
    offset: 'GMT+4',
  },
  {
    value: 'Europe/Uzhgorod',
    key: 'Europe/Uzhgorod',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Vaduz',
    key: 'Europe/Vaduz',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Vatican',
    key: 'Europe/Vatican',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Vienna',
    key: 'Europe/Vienna',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Vilnius',
    key: 'Europe/Vilnius',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Volgograd',
    key: 'Europe/Volgograd',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Warsaw',
    key: 'Europe/Warsaw',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Zagreb',
    key: 'Europe/Zagreb',
    offset: 'GMT+2',
  },
  {
    value: 'Europe/Zaporozhye',
    key: 'Europe/Zaporozhye',
    offset: 'GMT+3',
  },
  {
    value: 'Europe/Zurich',
    key: 'Europe/Zurich',
    offset: 'GMT+2',
  },
  {
    value: 'Indian/Antananarivo',
    key: 'Indian/Antananarivo',
    offset: 'GMT+3',
  },
  {
    value: 'Indian/Chagos',
    key: 'Indian/Chagos',
    offset: 'GMT+6',
  },
  {
    value: 'Indian/Christmas',
    key: 'Indian/Christmas',
    offset: 'GMT+7',
  },
  {
    value: 'Indian/Cocos',
    key: 'Indian/Cocos',
    offset: 'GMT+6:30',
  },
  {
    value: 'Indian/Comoro',
    key: 'Indian/Comoro',
    offset: 'GMT+3',
  },
  {
    value: 'Indian/Kerguelen',
    key: 'Indian/Kerguelen',
    offset: 'GMT+5',
  },
  {
    value: 'Indian/Mahe',
    key: 'Indian/Mahe',
    offset: 'GMT+4',
  },
  {
    value: 'Indian/Maldives',
    key: 'Indian/Maldives',
    offset: 'GMT+5',
  },
  {
    value: 'Indian/Mauritius',
    key: 'Indian/Mauritius',
    offset: 'GMT+4',
  },
  {
    value: 'Indian/Mayotte',
    key: 'Indian/Mayotte',
    offset: 'GMT+3',
  },
  {
    value: 'Indian/Reunion',
    key: 'Indian/Reunion',
    offset: 'GMT+4',
  },
  {
    value: 'Pacific/Apia',
    key: 'Pacific/Apia',
    offset: 'GMT+13',
  },
  {
    value: 'Pacific/Auckland',
    key: 'Pacific/Auckland',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Bougainville',
    key: 'Pacific/Bougainville',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Chatham',
    key: 'Pacific/Chatham',
    offset: 'GMT+12:45',
  },
  {
    value: 'Pacific/Easter',
    key: 'Pacific/Easter',
    offset: 'GMT-6',
  },
  {
    value: 'Pacific/Efate',
    key: 'Pacific/Efate',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Enderbury',
    key: 'Pacific/Enderbury',
    offset: 'GMT+13',
  },
  {
    value: 'Pacific/Fakaofo',
    key: 'Pacific/Fakaofo',
    offset: 'GMT+13',
  },
  {
    value: 'Pacific/Fiji',
    key: 'Pacific/Fiji',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Funafuti',
    key: 'Pacific/Funafuti',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Galapagos',
    key: 'Pacific/Galapagos',
    offset: 'GMT-6',
  },
  {
    value: 'Pacific/Gambier',
    key: 'Pacific/Gambier',
    offset: 'GMT-9',
  },
  {
    value: 'Pacific/Guadalcanal',
    key: 'Pacific/Guadalcanal',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Guam',
    key: 'Pacific/Guam',
    offset: 'GMT+10',
  },
  {
    value: 'Pacific/Honolulu',
    key: 'Pacific/Honolulu',
    offset: 'GMT-10',
  },
  {
    value: 'Pacific/Johnston',
    key: 'Pacific/Johnston',
    offset: 'GMT-10',
  },
  {
    value: 'Pacific/Kiritimati',
    key: 'Pacific/Kiritimati',
    offset: 'GMT+14',
  },
  {
    value: 'Pacific/Kosrae',
    key: 'Pacific/Kosrae',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Kwajalein',
    key: 'Pacific/Kwajalein',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Majuro',
    key: 'Pacific/Majuro',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Marquesas',
    key: 'Pacific/Marquesas',
    offset: 'GMT-9:30',
  },
  {
    value: 'Pacific/Midway',
    key: 'Pacific/Midway',
    offset: 'GMT-11',
  },
  {
    value: 'Pacific/Nauru',
    key: 'Pacific/Nauru',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Niue',
    key: 'Pacific/Niue',
    offset: 'GMT-11',
  },
  {
    value: 'Pacific/Norfolk',
    key: 'Pacific/Norfolk',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Noumea',
    key: 'Pacific/Noumea',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Pago_Pago',
    key: 'Pacific/Pago_Pago',
    offset: 'GMT-11',
  },
  {
    value: 'Pacific/Palau',
    key: 'Pacific/Palau',
    offset: 'GMT+9',
  },
  {
    value: 'Pacific/Pitcairn',
    key: 'Pacific/Pitcairn',
    offset: 'GMT-8',
  },
  {
    value: 'Pacific/Ponape',
    key: 'Pacific/Ponape',
    offset: 'GMT+11',
  },
  {
    value: 'Pacific/Port_Moresby',
    key: 'Pacific/Port_Moresby',
    offset: 'GMT+10',
  },
  {
    value: 'Pacific/Rarotonga',
    key: 'Pacific/Rarotonga',
    offset: 'GMT-10',
  },
  {
    value: 'Pacific/Saipan',
    key: 'Pacific/Saipan',
    offset: 'GMT+10',
  },
  {
    value: 'Pacific/Tahiti',
    key: 'Pacific/Tahiti',
    offset: 'GMT-10',
  },
  {
    value: 'Pacific/Tarawa',
    key: 'Pacific/Tarawa',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Tongatapu',
    key: 'Pacific/Tongatapu',
    offset: 'GMT+13',
  },
  {
    value: 'Pacific/Truk',
    key: 'Pacific/Truk',
    offset: 'GMT+10',
  },
  {
    value: 'Pacific/Wake',
    key: 'Pacific/Wake',
    offset: 'GMT+12',
  },
  {
    value: 'Pacific/Wallis',
    key: 'Pacific/Wallis',
    offset: 'GMT+12',
  },
]
